<!-- We need the txTemplateDesignerContainer id to apply the correct styling -->
<div id="txTemplateDesignerContainer" *ngIf="expanded">
  <div class="tab-content txdocs-ribbon-bar prevent-selection" id="ribbonTabTxdocs">
    <tx-section-navigate-fields
      [disabled]="!isActiveDocument"
      [unansweredCount]="unansweredCount"
      (previousClicked)="previousClicked.emit()"
      (nextClicked)="nextClicked.emit()"
      (showUnansweredOnlyChanged)="showUnansweredOnlyChanged.emit($event)"></tx-section-navigate-fields>
    <tx-section-search-fields
      [disabled]="!isActiveDocument"
      (searchClicked)="searchClicked.emit($event)"></tx-section-search-fields>
    <tx-section-portal></tx-section-portal>
    <tx-section-letterhead></tx-section-letterhead>
    <tx-section-signatures></tx-section-signatures>
    <tx-section-addresses></tx-section-addresses>
    <!-- <tx-section-find-and-replace></tx-section-find-and-replace> -->
    <tx-section-snippets></tx-section-snippets>
  </div>
</div>
